export const sortReadingScale = (scaleA, scaleB) => {
  const isPositiveA = scaleA >= 0;
  const isPositiveB = scaleB >= 0;
  if (isPositiveA !== isPositiveB) {
    return isPositiveA ? -1 : 1;
  }
  return Math.abs(scaleA) - Math.abs(scaleB);
};

export const formatReadingScale = (value) =>
  Number(value).toLocaleString("pt-BR", {
    maximumFractionDigits: 1,
    useGrouping: false,
  });
